"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _color = _interopRequireDefault(require("color"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    maxHeight: "100%",
    outline: "none",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(6)
    }
  },
  content: {
    background: "#FFFFFF",
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    flexDirection: "column",
    maxHeight: "clamp(280px, 90%, 500px)",
    maxWidth: 700,
    overflow: "auto",
    padding: theme.spacing(5, 2),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4, 6)
    }
  },
  header: {
    alignItems: "center",
    display: "flex",
    margin: theme.spacing(0, 0, 4)
  },
  close: {
    border: "1.5px solid transparent",
    borderColor: (0, _color.default)(theme.palette.text.primary).alpha(0.6).string(),
    borderRadius: "50%",
    cursor: "pointer",
    lineHeight: 1,
    margin: "0 0 0 auto",
    padding: theme.spacing(1),
    transition: "border-color 200ms ease",
    "&:hover": {
      borderColor: theme.palette.text.primary
    },
    "& svg": {
      fill: (0, _color.default)(theme.palette.text.primary).alpha(0.6).string(),
      transition: "fill 200ms ease"
    },
    "&:hover svg": {
      fill: theme.palette.text.primary
    }
  }
}));
const UIModal = props => {
  const {
    open,
    setOpen,
    headline
  } = props;
  const css = useStyles();
  const iconClose = /*#__PURE__*/_react.default.createElement("div", {
    className: css.close,
    onClick: () => {
      setOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    width: "18",
    height: "18",
    style: {
      display: "block"
    },
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.793 7.5L1.146 1.854l.708-.708L7.5 6.793l5.646-5.647l.708.708L8.207 7.5l5.647 5.646l-.707.707L7.5 8.207l-5.646 5.646l-.708-.707L6.793 7.5z"
  })), /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    width: "15",
    height: "15",
    fill: "rgba(0, 0, 0, 0)"
  })));
  return /*#__PURE__*/_react.default.createElement(_core.Modal, {
    className: css.modal,
    open: open,
    onClose: () => {
      setOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.wrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.content
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.header
  }, headline ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, headline) : "", iconClose), props.children)));
};
var _default = exports.default = UIModal;